import moment from "moment";
import { forwardRef } from "react";
import DatePicker from "react-datepicker";
import { CalenderIcon } from "assets/svgs";
import "react-datepicker/dist/react-datepicker.css";
import { userSettingState } from "store/selectors";
import { useAppSelector } from "store/hooks";
import styles from "./styles.module.css";

export function CustomDateInput({
  onChange,
  value,
  disabled = false,
  minDate,
  maxDate,
}: any) {
  const { isDarkMode } = useAppSelector(userSettingState);
  const minimumDate = minDate
    ? {
        minDate,
      }
    : {};
  const maximumDate = maxDate
    ? {
        maxDate,
      }
    : {};
  return (
    <div
      className={`${styles.customDateInput} ${
        isDarkMode ? "dark-mode-date-picker" : ""
      }`}
    >
      <DatePicker
        selected={value}
        disabled={disabled}
        onChange={(date: any) => {
          const convertedDate = moment(date).format("YYYY-MM-DD");
          onChange(convertedDate);
        }}
        customInput={<CustomDate disabled={disabled} />}
        dateFormat="dd-MM-yyyy" // Customize date format if needed
        {...minimumDate}
        {...maximumDate}
      />
    </div>
  );
}

const CustomDate = forwardRef(({ value, onClick, disabled }: any, ref: any) => {
  const { isDarkMode } = useAppSelector(userSettingState);
  return (
    <button
      type="button"
      className={`${styles.dateSelectBtn} ${isDarkMode ? styles.darkMode : ""}`}
      onClick={onClick}
      disabled={disabled}
      ref={ref}
    >
      <span className={value ? styles.value : styles.placeholder}>
        {value || "Select date"}
      </span>
      <CalenderIcon />
    </button>
  );
});
